import React from "react";

// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Grid, Typography } from "@mui/material";
// import { GridColDef, GridActionsCellItem } from "@mui/x-data-grid-pro";
// import { Link } from "react-router-dom";
import { DataGridComponent } from "../../components/common/DataGridComponent";
// import AttachFileIcon from "@mui/icons-material/AttachFile";
import useReportsColumns from "../../components/Reports/useReportsColumns";
import { useReportDetails } from "../../components/Reports/useReportsDetails";
import { useNavigate } from "react-router-dom";

const Reports: React.FunctionComponent<any> = () => {
  const columns = useReportsColumns();
  const { rowData } = useReportDetails();
  const navigate = useNavigate();
  const actions = {
    id: (data: any) => {
      navigate(`/reports/${data?.id}`);
    },
    pdf: (data: any) => {
      //   console.debug(data);
    },
    actionsColumn: {
      action_edit: (data: any) => {
        // console.debug(data)
      },
      action_delete: (data: any) => (data: any) => {
        // console.debug(data)
      },
    },
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography variant="h4" gutterBottom>
            Reports
          </Typography>
        </Grid>
        <Grid item justifyContent="flex-end">
          &nbsp;
        </Grid>
      </Grid>
      <Box sx={{ width: "100%", height: "calc(100vh - 150px)" }}>
        <DataGridComponent
          columns={columns as any}
          hasDefinedColumns={false}
          rows={rowData ?? []}
          showQuickFilter
          actions={actions}
        />
      </Box>
    </>
  );
};

export default Reports;
